export enum PaymentPeriod {
  HOUR = 'Per hour',
  DAY = 'Per day',
}
export interface PaymentPeriodType {
  id: string;
  title: string;
}
